import { render, staticRenderFns } from "./ApplicationEditor.vue?vue&type=template&id=347fd4c3"
import script from "./ApplicationEditor.vue?vue&type=script&lang=js"
export * from "./ApplicationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports